import { inject, Injectable } from '@angular/core';
import { ConfigLoaderService } from '@core/config-angular';
import type { RudderAnalytics } from '@rudderstack/analytics-js/*';

import type { JourneyAnalytics } from './models';

@Injectable({ providedIn: 'root' })
export class JourneyAnalyticsStub implements JourneyAnalytics {
  readonly #config = inject(ConfigLoaderService).getConfigAsync();
  #version = '';

  /* istanbul ignore next */
  async init() {
    this.#version = (await this.#config).version;

    if (this.#version === 'local-dev') {
      console.log(
        '%c[Journey Analytics]%c 🚫 disabled. A catch-all stub is initialized instead.',
        'color: blue; font-weight: bold;',
        'color: inherit; font-weight: normal;'
      );
    }
  }

  /* istanbul ignore next */
  getImplementation() {
    return new Proxy<RudderAnalytics>({} as RudderAnalytics, {
      get: (_target: any, prop: string | symbol) => {
        return (...args: any[]) => {
          // Only log on the local development environment.
          if (this.#version === 'local-dev') {
            console.groupCollapsed(
              `%c[Journey Analytics]%c Call to '${String(prop)}' was ignored.`,
              'color: blue; font-weight: bold;',
              'color: inherit; font-weight: normal;'
            );
            if (args.length === 0) {
              console.log('No arguments were provided.');
            } else {
              args.forEach((arg, index) => {
                if (
                  typeof arg === 'object' &&
                  arg !== null &&
                  !Array.isArray(arg)
                ) {
                  console.log(`Argument ${index} (Object Properties):`);
                  console.table(arg);
                } else {
                  console.log(`Argument ${index}:`, arg);
                }
              });
            }
            console.groupEnd();
          }
        };
      },
    });
  }
}
